import { MutationType } from '@tencent/slide-sdk-pb-model';
import { tableMergedRanges } from './../utils/table-utils';
import type { ITableData } from '../data';
import type { KeyframeContext } from './keyframe-context.interface';
import type { MarkRequired } from 'ts-essentials';
import type {
    ITableRangeData,
    IValidMutationData,
    IValidInsertTableRowMutationData,
    IValidSetTextDataMutationData,
    IValidSetTableCellPropertiesMutationData,
    IValidInsertTableColMutationData,
    IValidSetTableRowHeightsMutationData,
    IValidSetTableColWidthsMutationData,
    IValidMergeTableCellsMutationData,
} from '@tencent/slide-sdk-model';

export function getTableKeyframe(
    table: ITableData,
    context: MarkRequired<KeyframeContext, 'page'>,
): IValidMutationData[] {
    const mutationDatas: Array<
        | IValidInsertTableRowMutationData
        | IValidInsertTableColMutationData
        | IValidSetTableCellPropertiesMutationData
        | IValidSetTableRowHeightsMutationData
        | IValidSetTableColWidthsMutationData
        | IValidSetTextDataMutationData
        | IValidMergeTableCellsMutationData
    > = [];

    const tbl = table.graphic?.graphicData?.tbl;
    if (!tbl) return [];

    const shapeId = context.idFactory(table.id);
    const pageId = context.idFactory(context.page.id);

    tbl?.tr?.forEach((row, rowIndex) => {
        // 设置单元格属性
        const setTableCellPrData: IValidSetTableCellPropertiesMutationData[] = [];
        row?.tc?.forEach((tc, tcIndex) => {
            tc?.tcPr &&
                setTableCellPrData.push({
                    type: MutationType.SetTableCellProperties,
                    pageId,
                    shapeId,
                    range: {
                        startRowIndex: rowIndex,
                        startColIndex: tcIndex,
                        rowSpan: 1,
                        colSpan: 1,
                    },
                    tableCellProperties: tc.tcPr,
                });
        });
        mutationDatas.push(...setTableCellPrData);
    });

    // 设置行高/列宽
    const setTableHeightsMutation: IValidSetTableRowHeightsMutationData = {
        type: MutationType.SetTableRowHeights,
        pageId,
        shapeId,
        heights:
            tbl?.tr?.map((row, rowIndex) => ({
                index: rowIndex,
                height: row?.h || 0,
            })) || [],
    };
    const setTableWidthsMutation: IValidSetTableColWidthsMutationData = {
        type: MutationType.SetTableColWidths,
        pageId,
        shapeId,
        widths:
            tbl.tblGrid?.gridCol?.map((grid, gridIndex) => ({
                index: gridIndex,
                width: grid?.w || 0,
            })) || [],
    };
    mutationDatas.push(setTableHeightsMutation, setTableWidthsMutation);

    // 合并单元格
    const mergedRange = tableMergedRanges(tbl);
    mutationDatas.push(
        ...mergedRange.map((range: Required<ITableRangeData>) => ({
            type: MutationType.MergeTableCells,
            pageId,
            shapeId,
            range,
        })),
    );

    return mutationDatas;
}
